import { render, staticRenderFns } from "./VillainCard.vue?vue&type=template&id=1f3c0588&scoped=true"
import script from "./VillainCard.vue?vue&type=script&lang=js"
export * from "./VillainCard.vue?vue&type=script&lang=js"
import style0 from "./VillainCard.vue?vue&type=style&index=0&id=1f3c0588&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.28_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_cy24jmswklxzc46cxvuobxvpsa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3c0588",
  null
  
)

export default component.exports